import {
  SegmentedControl as _SegmentedControl,
  type MantineStyleProps,
  type SegmentedControlItem,
  type SegmentedControlProps,
} from "@mantine/core";

type Props = {
  data: (string | SegmentedControlItem)[];
} & MantineStyleProps &
  SegmentedControlProps;

export function SegmentedControl(props: Props) {
  const { data, ...segmentedControlProps } = props;
  const defaultOption: SegmentedControlProps = {
    data: data,
  };
  const option = Object.assign({}, defaultOption, segmentedControlProps);
  return <_SegmentedControl {...option} />;
}
